<template> 
  <div class="">
    <div class="flex items-center justify-center gap-2 py-4">
      <div
        v-for="(_, i) in range" 
        :key="i"
        class="card display-number flex h-14 w-12 items-center justify-center p-2 text-3xl font-medium shadow-none"
      >
        {{ number[i] }}
      </div>
    </div>

    <div class="mx-auto grid max-w-xs grid-cols-3 gap-2 pb-4">
      <button
        v-for="i in Array.from({ length: 9 }, (_, i) => i + 1)"
        :key="i"
        class="numpad min-h-[2.5rem] py-1.5 text-xl outline-none"
        type="button"
        @click="addDigit(i)"
      >
        <div class="flex items-center justify-center">
          <span>{{ i }}</span>
        </div>
      </button>
      <button
        class="numpad min-h-[2.5rem] py-1.5 text-xl outline-none"
        type="button"
        :disabled="!number.length"
        @click="removeDigit"
      >
        <div class="flex items-center justify-center">
          <svg
            data-v-aee14c88=""
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            aria-hidden="true"
            class="h-6 w-6"
          ><path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z"
          ></path></svg>
        </div>
      </button>
      <button
        class="numpad min-h-[2.5rem] py-1.5 text-xl outline-none"
        type="button"
        @click="addDigit(0)"
      >
        <div class="flex items-center justify-center">
          <span>0</span>
        </div>
      </button>
      <button
        class="numpad min-h-[2.5rem] py-1.5 text-xl outline-none"
        type="button"
        disabled=""
      >
        <div class="flex items-center justify-center">
          <span></span>
        </div>
      </button>
    </div>
  </div>
</template>
<script>   
export default { 
    props:{
      maxDigit: {
        type: Number,
        default: 3
      },
    },
    data (){
      return { 
        number: '',
      }
    },
    computed : { 
      range () {
        return Array.from({ length: this.maxDigit }, (_, i) => i + 1);
      },
    },
    watch:{   
      maxDigit () { 
        this.number = ''
      },
    }, 
    methods : {
       addDigit (number) {
          this.$ga.event('Button', 'AddValue', 'NumPad', number)
          this.number += number

          if (this.number.length == this.maxDigit) {
            this.$emit('enter', this.number)

            setTimeout(() => {
              this.number = ''
            }, 200);
          }
       },
       removeDigit (){
          this.$ga.event('Button', 'RemoveDigitalNumber', 'NumPad', '')

          this.number = this.number.slice(0, -1); 
       }, 
    }
    
    
}
</script>
<style scoped>
.max-w-xs {
  max-width: 20rem !important;
}

.numpad {
  --tw-text-opacity: 1;
  background-image: linear-gradient(to right, #171717, #383838);
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.btn, [type=button], [type=submit], button {
  align-items: center;
  background-color: var(--bg-secondary-color-v2);
  border-radius: .375rem;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 1rem;
  font-weight: 500;
  height: auto;
  justify-content: center;
  line-height: 1.5rem;
  padding: .5rem .75rem;
  touch-action: manipulation;
  transition: all .3s cubic-bezier(.4,0,.2,1);
}

.btn .disabled, .btn:disabled, [type=button] .disabled, [type=button]:disabled, [type=submit] .disabled, [type=submit]:disabled, button .disabled, button:disabled {
  cursor: not-allowed !important;
  opacity: .5;
  pointer-events: none;
}

.w-6 {
  width: 1.5rem !important;
}

.h-6 {
  height: 1.5rem !important;
}

.display-number {
  --tw-text-opacity: 1 !important;
  background: radial-gradient(ellipse at center top, #383838, #171717) !important;
  color: rgb(255 255 255/ 1) !important;
  flex-grow: 0;
}

.card {
  background-color: #fff;
  border-radius: .5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
  height: auto;
}
</style>